/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FILTER_OPERATORS }        from 'g3w-constants';
import ApplicationState            from 'store/application';
import DataRouterService           from 'services/data';
import GUI                         from 'services/gui';
import { getUniqueDomId }          from 'utils/getUniqueDomId';
import { createFilterFromString }  from 'utils/createFilterFromString';
import { XHR }                     from 'utils/XHR';
import { getCatalogLayerById }     from 'utils/getCatalogLayerById';
import { prompt }                  from 'utils/prompt';
import { gettext as _ }            from 'g3w-i18n';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'query-builder',

  data() {
    return {
      edit:         undefined !== this.$options.options,
      currentlayer: null,
      message:      '',
      filter:       (undefined !== this.$options.options ? this.$options.options.filter : ''),
      loading: {
        test:   false,
        values: false
      },
      values:      [],
      manual:      true,
      manualvalue: null,
      select: {
        field: null,
        value: null
      }
    }
  },

  computed:{

    fields() {
      return this.currentlayer ? this.currentlayer.fields : [];
    },

    disabled() {
      return !this.filter;
    },

  },

  watch: {

    'select.field'() {
      this.values = [];
      this.manual = true;
    },

  },

  methods: {

    addToExpression({ value, type } = {}) {
      switch(type) {
        case 'operator': value = ` ${value} `; break;
        case 'field':    value = `"${value}"`; break;
        case 'value':    value = `'${value}'`; break;
      }
      if (value) this.filter = (`${this.filter}${value}`);
    },

    /**
     * ORIGINAL SOURCE: src/services/querybuilder.js@v3.9.3
     */
    async all() {
      this.loading.values = true;
      try {
        let layerId    = this.currentlayer.id;
        let field      = this.select.field;
        let CACHE      = ApplicationState.querybuilder.cache;
        CACHE[layerId] = CACHE[layerId] || {};
        if (undefined !== CACHE[layerId][field]) {
          this.values = CACHE[layerId][field];
        } else {
          const response = await XHR.get({
            url: getCatalogLayerById(layerId).getUrl('data'),
            params: { ordering: field, formatter: 1, fformatter: field }
          });
          if (response.result) {
            CACHE[layerId][field] = CACHE[layerId][field] || response.data;
          }
          this.values = CACHE[layerId][field] || [];
        }
      } catch(e) {
        console.warn(e);
      }
      this.loading.values = false;
      await this.$nextTick();
      this.manualvalue    = null;
      this.manual         = false;
    },

    reset() {
      this.filter                 = '';
      this.message                = '';
      this.filterElement.previous = null;
      this.filterElement.current  = null;
      this.filterElement.operator = null;
      this.select.field           = null;
      if (this.$refs.search_fields) { this.$refs.search_fields.selectedIndex = -1 }
      if (this.$refs.search_values) { this.$refs.search_values.selectedIndex = -1 }
    },

    /**
     * ORIGINAL SOURCE: src/services/querybuilder.js@v3.9.3
     */
    async run() {
      try {
        this.loading.test = true;
        const layer       = getCatalogLayerById(this.currentlayer.id);
        const { data }    = await DataRouterService.getData('search:features', {
          inputs: {
            layer,
            filter: createFilterFromString({ layer, filter: this.filter }),
            feature_count: 100,
          },
          outputs: true,
        });
        const n         = data.length && data[0].features.length; // number of features
        this.message    = undefined === n ? '' : ` ${n}`;
        return data;
      } catch(e) {
        console.warn(e);
      } finally {
        this.loading.test = false;
      }
    },

    /**
     * ORIGINAL SOURCE: src/services/querybuilder.js@v3.9.3
     */
    async save() {
      const id      = this.projectId || ApplicationState.project.getId();
      const edit_id = this.edit && this.$options.options.id;
      const item    = window.localStorage.getItem('QUERYBUILDERSEARCHES');
      let searches  = item ? JSON.parse(item) : undefined;

      let query;

      try {
        query = {
          layerId:   this.currentlayer.id,
          filter:    this.filter,
          layerName: getCatalogLayerById(this.currentlayer.id).getName(),
          name:      edit_id ? (this.edit && this.$options.options.name) : await (new Promise((res, rej) => prompt({
            label: _('Insert the name of the new search'),
            value: '',
            callback: d => d ? res(d) : rej()
          }))),
          id:        edit_id || getUniqueDomId(),
        };

        // edit local item
        if (edit_id) {
          const i = searches[id].findIndex(s => s.id === query.id);
          if (-1 !== i) {
            searches[id][i] = query;
          }
        }

        // add local item
        else {
          GUI.getService('search').state.querybuildersearches.push(query); // add query builder search
          if (undefined === searches) {
            searches     = { [id]: [query] };
          } else {
            searches[id] = [...(searches[id] || []), query];
          }
        }
      } catch (e) {
        console.warn(e);
        return;
      }

      // reset items
      const ITEMS = ApplicationState.querybuilder.searches;
      
      try {
        window.localStorage.setItem('QUERYBUILDERSEARCHES', JSON.stringify(searches));
      } catch(e) {
        console.warn(e);
      }

      setTimeout(() => { searches[id].forEach(q => ITEMS[id].push(q)); }, 0);
      ITEMS[id].splice(0);
      GUI.showUserMessage({ type: 'success', message: _('Saved'), autoclose: true });
    },

  },

  created() {

    this.filterElement = {
      current:  null,
      previous: null,
      operator: null
    };

    const project = ApplicationState.project;

    this.layers = project
      .getLayers()
      .filter(l => !l.baselayer && Array.isArray(l.fields))
      .map(layer => {
        // exclude join fields
        let exclude = [];
        project.state.relations
          .filter(r => layer.id === r.referencedLayer && 'ONE' === r.type) // get relations by layerId
          .forEach( r => {
            const l = project.getLayerById(r.referencingLayer);
            r.customPrefix = r.customPrefix === undefined ? `${l.getName()}_` : r.customPrefix;
            exclude = [...exclude, ...l.getFields().map(field => `${r.customPrefix}${field.name}`)];
          });
        return {
          id:     layer.id,
          label:  layer.title,
          fields: layer.fields.filter(f => f.show).map(f => ({ label: f.label, name: f.name })).filter(f => !exclude.includes(f))
        }
      });

    this.operators    = Object.values(FILTER_OPERATORS);

    this.currentlayer = this.edit ? this.layers.find(l => l.id === this.$options.options.layerId) : this.layers[0];

  },

  async mounted() {
    await this.$nextTick();

    this.select2 = $('#query_builder_layers_select').select2({ width: '100%' });

    if (this.edit) {
      this.select2.val(this.layers.indexOf(this.currentlayer));
      this.select2.trigger('change');
    }

    this.select2.on('select2:select', e => {
      this.currentlayer = this.layers[e.params.data.id];
      this.select.field = null;
      this.select.value = null;
      this.reset();
    });
  },

  beforeDestroy() {
    this.select2.select2('destroy');
    this.select2 = null;
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",attrs:{"id":"query_builder"}},[_c('div',{staticClass:"mb-5",attrs:{"id":"query_builder_layers"}},[_c('label',{directives:[{name:"t",rawName:"v-t",value:('EXPRESSION'),expression:"'EXPRESSION'"}],staticClass:"querybuilder-title"}),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":"https://g3w-suite.readthedocs.io/en/v3.9.x/g3wsuite_client.html#search-and-query-builder","target":"_blank","data-i18n-title":"Docs","data-placement":"right"}},[_c('i',{class:_vm.$fa('external-link')})]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"query_builder_layers_select"}},_vm._l((_vm.layers),function(layer,i){return _c('option',{key:layer.label,staticClass:"bold",domProps:{"value":i}},[_vm._v(_vm._s(layer.label))])}),0)]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],attrs:{"id":"query_builder_expression_content"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}}),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading.test}}),_vm._v(" "),_c('b',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"skin-color"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('Features found:'),expression:"'Features found:'"}]}),_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"content-end"},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('RUN'),expression:"'RUN'"}],staticClass:"query_builder_button btn btn-secondary bold",attrs:{"disabled":_vm.disabled},on:{"click":_vm.run}},[_c('i',{class:_vm.$fa('run'),staticStyle:{"color":"green"}})]),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('CLEAR'),expression:"'CLEAR'"}],staticClass:"query_builder_button btn btn-secondary bold",on:{"click":_vm.reset}},[_c('i',{class:_vm.$fa('clear')})]),_vm._v(" "),_c('button',{directives:[{name:"t",rawName:"v-t",value:('SAVE'),expression:"'SAVE'"}],staticClass:"query_builder_button btn btn-secondary bold",attrs:{"disabled":_vm.disabled},on:{"click":_vm.save}},[_c('i',{class:_vm.$fa('save')})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',{directives:[{name:"t",rawName:"v-t",value:('FIELDS'),expression:"'FIELDS'"}]}),_vm._v(" "),_c('select',{ref:"search_fields",staticClass:"mb-5",attrs:{"size":"4"}},[_c('option',{attrs:{"selected":"","hidden":""}}),_vm._v(" "),_vm._l((_vm.fields),function(field){return _c('option',{key:field.name,on:{"click":function($event){_vm.select.field = field.name; _vm.addToExpression({ value: field.name, type: 'field' })}}},[_vm._v(_vm._s(field.label))])})],2),_vm._v(" "),_c('div',{staticClass:"content-wrap mb-5"},_vm._l((_vm.operators),function(operator){return _c('button',{key:operator,staticClass:"query_builder_button btn btn-secondary bold",on:{"click":function($event){return _vm.addToExpression({ value: operator, type: 'operator' })}}},[_vm._v(_vm._s(operator))])}),0),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading.values}}),_vm._v(" "),(!_vm.manual)?_c('select',{ref:"search_values",staticClass:"mb-5",attrs:{"size":"4"}},[_c('option',{attrs:{"selected":"","hidden":""}}),_vm._v(" "),_vm._l((_vm.values),function(ref){
var key = ref[0];
var value = ref[1];
return _c('option',{key:key,on:{"click":function($event){_vm.select.value = key; _vm.addToExpression({ value: key, type: 'value' })}}},[_vm._v(_vm._s(value))])})],2):_vm._e(),_vm._v(" "),(_vm.select.field !== null && !_vm.values.length)?_c('button',{staticClass:"btn btn-secondary bold",class:{'skin-border-color' : !_vm.manual },staticStyle:{"color":"#000"},on:{"click":_vm.all}},[_c('i',{class:_vm.g3wtemplate.getFontClass('search')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('SEARCH A VALUE'),expression:"'SEARCH A VALUE'"}]})]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5e907e2b_0", { source: "#query_builder[data-v-5e907e2b]{margin-bottom:0;height:100%;display:flex;flex-wrap:nowrap;flex-direction:column}#query_builder .select2.select2-container[data-v-5e907e2b]{font-weight:700}.querybuilder-title[data-v-5e907e2b]{color:#fff;font-weight:700}select[data-v-5e907e2b]{background-color:#fff;color:#000;border:none}option[data-v-5e907e2b]{padding:8px;cursor:pointer}option[data-v-5e907e2b]:checked{background:var(--skin-color) linear-gradient(0deg,var(--skin-color) 0,var(--skin-color) 100%);color:#fff}option[data-v-5e907e2b]:nth-of-type(2n+1){background-color:#f9f9f9}.query_builder_button[data-v-5e907e2b]{margin:1px;flex-basis:78px;flex-grow:1;color:#000}.content-wrap[data-v-5e907e2b]{display:flex;flex-wrap:wrap}.content-end[data-v-5e907e2b]{display:flex;flex-wrap:wrap;justify-content:flex-end;margin-top:5px}.mb-5[data-v-5e907e2b]{margin-bottom:5px}#query_builder_expression_content[data-v-5e907e2b]{width:100%;resize:none;height:100px;color:#000}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-5e907e2b"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QueryBuilder.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__